import { useEffect, useState } from 'react'

export const useGetCustomerCountdownBannerList = (customerNumber) => {
    const [customerCountdownBannerList, setCustomerCountdownBannerList] = useState()

    useEffect(() => {
        (async () => {
            try {
                const  url= `${process.env.REACT_APP_BASE_PATH}/apps/store/api/v1.0/banner/${customerNumber}`
                const response = await fetch(url, { signal: AbortSignal.timeout(5000) })
                const data = await response.json();

                if (data?.length > 0) {
                    setCustomerCountdownBannerList(data)
                }
            } catch (error) {
                console.log('Failed to get customer countdown banner list: ', error)
            }
        })()
    },[])

    return customerCountdownBannerList
}